/**
 * GoNOW API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2020-12-7
 * Contact: info@zero-spec.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from "../ApiClient";
import CreateTankTypeRequest from '../model/CreateTankTypeRequest';
import CreateTankTypeResponse from '../model/CreateTankTypeResponse';
import ErrorResponse from '../model/ErrorResponse';
import GetTankTypeResponse from '../model/GetTankTypeResponse';
import SearchTankTypeResponse from '../model/SearchTankTypeResponse';
import UpdateTankTypeRequest from '../model/UpdateTankTypeRequest';
import UpdateTankTypeResponse from '../model/UpdateTankTypeResponse';

/**
* TankTypes service.
* @module api/TankTypesApi
* @version 2020-12-7
*/
export default class TankTypesApi {

    /**
    * Constructs a new TankTypesApi. 
    * @alias module:api/TankTypesApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instance} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }



    /**
     * タンクタイプを登録する 
     * @param {Object} opts Optional parameters
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/CreateTankTypeResponse} and HTTP response
     */
    createTankTypesWithHttpInfo(body, opts) {
      opts = opts || {};
      let postBody = body;

      let pathParams = {
      };
      let queryParams = {
        'upsert': opts['upsert']
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['tokenAuth'];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = CreateTankTypeResponse;

      return this.apiClient.callApi(
        '/tank-types', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType
      );
    }

    /**
     * タンクタイプを登録する 
     * @param {Object} opts Optional parameters
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/CreateTankTypeResponse}
     */
    createTankTypes(body, opts) {
      return this.createTankTypesWithHttpInfo(body, opts)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * タンクタイプを1件取得する
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/GetTankTypeResponse} and HTTP response
     */
    getTankTypeWithHttpInfo(tankTypeId) {
      let postBody = null;

      let pathParams = {
        'tankTypeId': tankTypeId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['tokenAuth'];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = GetTankTypeResponse;

      return this.apiClient.callApi(
        '/tank-types/{tankTypeId}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType
      );
    }

    /**
     * タンクタイプを1件取得する
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/GetTankTypeResponse}
     */
    getTankType(tankTypeId) {
      return this.getTankTypeWithHttpInfo(tankTypeId)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * タンクタイプを全件取得する
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/SearchTankTypeResponse} and HTTP response
     */
    searchTankTypesWithHttpInfo() {
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['tokenAuth'];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = SearchTankTypeResponse;

      return this.apiClient.callApi(
        '/tank-types', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType
      );
    }

    /**
     * タンクタイプを全件取得する
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/SearchTankTypeResponse}
     */
    searchTankTypes() {
      return this.searchTankTypesWithHttpInfo()
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * preflight
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link 'String'} and HTTP response
     */
    tankTypesIdPreflightWithHttpInfo(tankTypeId) {
      let postBody = null;

      let pathParams = {
        'tankTypeId': tankTypeId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['tokenAuth'];
      let contentTypes = [];
      let accepts = ['text/plain'];
      let returnType = 'String';

      return this.apiClient.callApi(
        '/tank-types/{tankTypeId}', 'OPTIONS',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType
      );
    }

    /**
     * preflight
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link 'String'}
     */
    tankTypesIdPreflight(tankTypeId) {
      return this.tankTypesIdPreflightWithHttpInfo(tankTypeId)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * preflight
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link 'String'} and HTTP response
     */
    tankTypesPreflightWithHttpInfo() {
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['tokenAuth'];
      let contentTypes = [];
      let accepts = ['text/plain'];
      let returnType = 'String';

      return this.apiClient.callApi(
        '/tank-types', 'OPTIONS',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType
      );
    }

    /**
     * preflight
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link 'String'}
     */
    tankTypesPreflight() {
      return this.tankTypesPreflightWithHttpInfo()
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * タンクタイプを更新する
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/UpdateTankTypeResponse} and HTTP response
     */
    updateTankTypeWithHttpInfo(body, tankTypeId) {
      let postBody = body;

      let pathParams = {
        'tankTypeId': tankTypeId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['tokenAuth'];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = UpdateTankTypeResponse;

      return this.apiClient.callApi(
        '/tank-types/{tankTypeId}', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType
      );
    }

    /**
     * タンクタイプを更新する
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/UpdateTankTypeResponse}
     */
    updateTankType(body, tankTypeId) {
      return this.updateTankTypeWithHttpInfo(body, tankTypeId)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }

}
